import { createContext, useEffect, useState } from "react";

export const AffiliateContext = createContext({
  affiliate: "",
});
export const AffiliateProvider = ({ children }) => {
  const [affiliate, setAffiliate] = useState("");
  const [accountType, setAccountType] = useState("");
  useEffect(() => {
    if (localStorage.getItem("affiliate")) {
      setAffiliate(localStorage.getItem("affiliate"));
    }
    if (localStorage.getItem("affiliateType")) {
      setAccountType(localStorage.getItem("affiliateType"));
    }
  }, []);
  const value = { affiliate, accountType, setAffiliate, setAccountType };
  return (
    <AffiliateContext.Provider value={value}>
      {children}
    </AffiliateContext.Provider>
  );
};
